import { OwaDate, owaDate, isAfter } from 'owa-datetime';
import { OwaDateRange } from 'owa-datetime-utils/lib/OwaDateRange';
import owaDateFromTzDateTimeValues from './owaDateFromTzDateTimeValues';

export default function getDatesOnEndPartChanged(
    start: OwaDate,
    newEndTz: string,
    newEndDate: OwaDate,
    newEndTime: OwaDate
): OwaDateRange {
    let end = owaDateFromTzDateTimeValues(newEndTz, newEndDate, newEndTime);

    if (isAfter(start, end)) {
        // If new end is set to something before start, then update end to be start
        end = owaDate(newEndTz, start);
    }

    return { start, end };
}
